export const signupRoutes = ['step-1', 'step-2', 'step-3'];

export const bookingAuthRoutes = ['confirm-details', 'billing-information'];